// TODO:
// change api

import React, { Component } from 'react';

// react modal
import ReactModal from 'react-modal';

// prop types
import PropTypes from 'prop-types';

// react redux connect
import { connect } from 'react-redux';

// lodash is empty
import { isEmpty } from 'lodash';

// creating styled divs
import styled from 'styled-components';

// format phone number
import phoneFormatter from 'phone-formatter';

// material ui pickers
// material ui pickers
import MomentUtils from '@date-io/moment';

import {
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

import { withStyles } from '@material-ui/core/styles';

// icons
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

// material ui core
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  Button,
  IconButton,
  Grid
} from '@material-ui/core';

// homemade components
import {
  RegularCard,
  ItemGrid,
  CustomInput
} from "../../components";

// reducer actions
import {
  loadUsers,
  selectUser,
  deleteUser,
  createNewUser
} from './reducer/actions';

import { Redirect } from "react-router-dom";

// Custom Table Cell
const CustomTableCell = withStyles(theme => ({
  head: {
    textAlign: 'center'
  },
  body: {
    fontSize: 16,
    textAlign: 'center'
  },
}))(TableCell);

// root and table styles
const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  /* big button */
  button: {
    background: '#3399ff',
    color: 'white',
    width: 120,
    borderRadius: 5,
    fontSize: 12,
    fontWeight: 'bold',
    marginLeft: 10,
    marginTop: 5,
  },
});

// modal header, content, footer
const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 20px;
  border-bottom: 1px solid rgba(153, 153, 153, 0.7);
`
const ModalContent = styled.div`
  position: relative;
  padding: 0px 20px;
  overflow: hidden;
  padding-bottom: 20px;
  line-height: 50px;
`
const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid rgba(153, 153, 153, 0.7);
`

// const modal styles - overlay, content
const customModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 102, 128, 0.5)'
  },
  content: {
    top: 'calc(50% + 30px)',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px !important',
    width: '572px'
  }
};

const formatPhone = phone =>
  phone ?
    phone.length >= 10 ?
      phoneFormatter.format(phone, '(NNN) NNN-NNNN') :
      phone :
    null;

// Life...Life will be a great deal less weird without you.
// You know, I think that's the nicest thing anyone's ever said about me.

// class declaration
class CustomizedTable extends Component {

  // state constructor
  constructor (props) {
    super (props);
    this.state = {
      // show Add New User modal
      showModal: false,
      // user's name
      name: '',
      // user's email address
      email: '',
      // user's phone number
      phone: '',
      // user's imported point total
      point: 0,
    }
  }

  // load in users
  componentDidMount() {
    this.props.loadUsers();
  }

  // opens User Profile page upon pressing a user's Edit button
  selectUser(userId) {
    this.props.selectUser({ userId: userId });
    this.props.history.push(`/users/${userId}`);
  }

  // delete an existing user
  _onDeleteUser(id) {
    this.props.deleteUser(id);
  }

  // close the modal when actions are successful
  _onSuccess () {
    this.setState({ showModal: false });
  }

  // close the modal and report error
  _onError (error) {
    console.log(error);
    this.setState({ showModal: false });
  }

  // create a brand new User with provided data
  _onCreateNewUser () {
    // call Create New User prop
    this.props.createNewUser({
      name: this.state.name,
      email: this.state.email,
      phone: this.state.phone,
      point: Number(this.state.point),
    }, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // show Add User modal
  _onShowModal () {
    this.setState({
      name: '',
      email: '',
      phone: '',
      point: 0,
      showModal: true,
    });
  }

  // close Add User modal
  _onCloseModal () {
    this.setState({ showModal: false });
  }

  // modal that enables adding a new app user
  addUserModal() {
    return (
      <ReactModal isOpen={this.state.showModal}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={'New User'}
        ariaHideApp={false}
        style={customModalStyles}
        >
        {/* Modal Header */}
        <ModalHeader>
          New User
        </ModalHeader>
        {/* Modal content and input fields */}
        <ModalContent>
          <Grid container>
            {/* Name input box*/}
            <ItemGrid xs={8}>
              <CustomInput
                labelText='Name'
                id='name'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.name,
                  onChange: (e)=>this.setState({ name: e.target.value })
                }}
                />
            </ItemGrid>
            <ItemGrid xs={4} />
            {/* Email input box */}
            <ItemGrid xs={8}>
              <CustomInput
                labelText='Email'
                id='email'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.email,
                  onChange: (e)=>this.setState({ email: e.target.value })
                }}
                />
            </ItemGrid>
            <ItemGrid xs={4} />
            {/* Phone input field */}
            <ItemGrid xs={8}>
              <CustomInput
                labelText='Phone'
                id='phone'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.phone,
                  onChange: (e)=>this.setState({ phone: formatPhone(e.target.value) })
                }}
                />
            </ItemGrid>
            <ItemGrid xs={4} />
            {/* Point input field */}
            <ItemGrid xs={8}>
              <CustomInput
                labelText='Points'
                id='points'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.point,
                  onChange: (e)=>this.setState({ point: e.target.value })
                }}
                />
            </ItemGrid>
            <ItemGrid xs={4} />
          </Grid>
        </ModalContent>
        <ModalFooter>
          <Button
            variant='raised'
            primary={true}
            onClick={(e) => {this._onCreateNewUser()} }
          >
            Create
          </Button>
          <Button
            variant='raised'
            style={{ marginLeft: 20 }}
            onClick={(e) => {this.setState({ showModal: false })}}
          >
            Cancel
          </Button>
        </ModalFooter>
      </ReactModal>
    );
  }

  // component render
  render() {
    // make sure only authorized Users proceed
    // check for admin rights in general
    if (!this.props.user.hasOwnProperty('admin')) {
      return (
        <Redirect from={'users'} to={'dashboard'} key={'invalid'} />
      );
    }
    // check for rights for this page in particular
    if (!this.props.user.admin.master &&
      !this.props.user.admin.hasOwnProperty('users'))
    {
      return (
        <Redirect from={'users'} to={'dashboard'} key={'noTicket'} />
      );
    }

    const {
      classes,
      users,
      isLoading
    } = this.props;

    // render return
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
      {/* Regular Card contains contents of Page */}
      <RegularCard
        cardTitle="Users Stats"
        cardSubtitle="Users"
        content={
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                {/* User Icon header */}
                <CustomTableCell>
                  Icon
                </CustomTableCell>
                {/* User's Name header */}
                <CustomTableCell>
                  Name
                </CustomTableCell>
                {/* User's Email */}
                <CustomTableCell>
                  Email
                </CustomTableCell>
                {/* User total number of Rewards */}
                <CustomTableCell numeric>
                  Rewards
                </CustomTableCell>
                {/* User current number of Points */}
                <CustomTableCell numeric>
                  Points
                </CustomTableCell>
                {/* Edit/Delete icon header */}
                <CustomTableCell>
                  More
                </CustomTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {/* if Loading in progress, show a loading circle*/}
            {isLoading &&
              <div style={{padding: 10, textAlign: 'center'}}>
                <CircularProgress />
              </div>
            }
            {/* filter out non-subscribed Users
              this should probably be removed for non-master apps
              */}
            {!isLoading && !isEmpty(users) && users
              .map(n => {
              return (
              <TableRow className={classes.row} key={n.id}>
                {/* display user profile image */}
                <CustomTableCell component="th" scope="row" children={
                  <div
                    style={{
                      width: 64,
                      height: 64,
                      borderRadius: 32,
                      backgroundColor: '#ccc',
                      backgroundImage: `url("${n.profileImage}")`,
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: '50% 50%'
                    }}/>
                  }
                />
                {/* user's name */}
                <CustomTableCell>
                  {n.name}
                </CustomTableCell>
                {/* user email */}
                <CustomTableCell>
                  {n.email}
                </CustomTableCell>
                {/* number of user rewards, if applicable */}
                <CustomTableCell numeric>
                  {n.rewards ? Object.keys(n.rewards).length : 0}
                </CustomTableCell>
                {/* user point total */}
                <CustomTableCell numeric>
                  {n.point}
                </CustomTableCell>
                {/* button container */}
                <CustomTableCell>
                  {/* Edit User button */}
                  <IconButton
                    tooltip="Edit user"
                    iconStyle={{ fill: 'rgb(15, 102, 128)' }}
                    onClick={(e) => {this.selectUser(n.id)}}
                  >
                    <EditIcon />
                  </IconButton>
                  {/* Delete User button
Firebase Auth Delete requires the user to have logged in recently before they are deleted
so since that's not guaranteed or possible to do independently here, alert the user
                    */}
                  <IconButton
                    tooltip="Delete user"
                    iconStyle={{ fill: 'rgb(15, 102, 128)' }}
                    onClick={(e) => alert('To delete a user, please contact IT')}
                  >
                    <DeleteIcon />
                  </IconButton>
                </CustomTableCell>
              </TableRow>
              );
            })}
              {/* add user button */}
              <Button className={classes.button}
                onClick={this._onShowModal.bind(this)}
              >
                Add New User
              </Button>
            </TableBody>
            {this.addUserModal()}
          </Table>
        }
      />
      </MuiPickersUtilsProvider>
    );
  }
}

CustomizedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  users: state.userReducer.users,
  isLoading: state.userReducer.isLoading,
  user: state.authReducer.user,
  loggedIn: state.authReducer.loggedIn,
});

const mapDispatchToProps = {
  loadUsers,
  selectUser,
  deleteUser,
  createNewUser
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CustomizedTable));
